import styled from "styled-components";

export const BG = styled.div`
  background: var(--cores-B1DBF0, #B1DBF0);
`

export const Title = styled.h1`
  color: var(--Neutral-Gray-900, #1B1B19);
  text-align: center;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 110%; /* 44px */
  margin-bottom: 20px;
`;

export const TableContainer = styled.div`
  width: 100%;
  max-width: 690px;
  margin: 0 auto;
  padding: 20px;
`;

export const TableWrapper = styled.div`
  margin-bottom: 32px;
`;

export const TableHeader = styled.div`
  background-color: ${(props) => props.bgColor || "#0056b3"}; /* Cor do cabeçalho */
  text-align: left;
  padding: 8px 24px;

  color: var(--cores-ffffff, #FFF);
  font-size: 16px;
  font-style: normal;
  font-weight: 700;
  line-height: 24px; /* 150% */
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  background-color: white;
  border-radius: 0 0 4px 4px;
`;

export const TableHead = styled.thead`
  background-color: #f5f5f5;
`;

export const TableRow = styled.tr`
  background-color: #fff;
`;

export const TableCell = styled.th`
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;

  color: var(--cores-000000, #000);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  padding: 8px 24px;
  background: #F0F0F0;
`;

export const TableData = styled.td`
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;

  color: var(--Neutral-Gray-900, #1B1B19);
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 24px; /* 150% */
  padding: 8px 24px;
`;

export const ArrowLink = styled.a`
  cursor: pointer;
  color: #0056b3;
  font-size: 14px;
  margin-left: 5px;

  &:hover {
    text-decoration: underline;
  }
`;

export const Name = styled.div`
  display: flex;
  align-items: center;
`